import styled from "styled-components";

const Container = styled.div`
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid #f1f3f5;
  height: 53px;
  img {
    max-width: 24px;
    position: absolute;
    left: 16px;
    cursor: pointer;
    margin-right: 11px;
  }
`;

const SearchHeader = styled.div`
  position: relative;
  top: 0;
  left: 0;
  padding: 12px 16px;
  text-align: center;
  img {
    max-width: 24px;
    position: absolute;
    left: 16px;
    cursor: pointer;
  }
`;

const SearchInput = styled.div`
  overflow: hidden;
  box-sizing: border-box;
  position: relative;
  border-radius: 8px;
  height: 2.25rem;
  min-width: 285px;
  left: 8px;
  margin: 6px 16px;
  background-color: #f1f3f5;
  
  img {
    max-width: 20px;
    position: absolute;
    top: 8px;
    left: 12px;
  } 

    & + & {
    max-width: 20px;
    position: absolute;
    top: 8px;
    left: 50px;
    }

  input {
    width: 240px;
    border: none;
    position: absolute;
    top: 8px;
    left: 38px;
    color: #222529;
    font-size: 13px;
    background-color: #f1f3f5;
    outline: none;
    letter-spacing: -0.05em;
    caret-color: #FF7A00 ;
    &::placeholder {
      color: #878E95;
    }
    &::-webkit-search-cancel-button {
      -webkit-appearance: none;
      /* padding-right: 12px; */
      width: 18px;
      height: 18px;

      /* background: url(https://pro.fontawesome.com/releases/v5.10.0/svgs/solid/times-circle.svg) */
      background: url("/img/resetBtn.svg")
        no-repeat 50% 50%;

      /* background: url("../../../../assets/icons/CloseButton.svg") no-repeat; */
      background-size: contain;
      cursor: pointer;
    }
  }
  /* .close_button {
    max-width: 18px;
    position: absolute;
    top: 8px;
    left: 270px;
  } */
`;

const AutoKeyword = styled.div`
  border-bottom: 1px solid #f1f3f5;
  padding: 12px 16px;
  position: relative;
  img {
    max-width: 20px;
    position: absolute;
    top: 12px;
    left: 14px;
  }
  p {
    font-size: 0.875rem;
    color: #222529;
    margin-left: 35px;
    cursor: pointer;
  }
`;
export { Container, SearchHeader, SearchInput, AutoKeyword };